import { colors, space, radius } from "../../design/tokens";

export default function Screen({ children, style }) {
  return (
    <div
      style={{
        width: "100%",
        minheight: "100dvh",
        ...style,
      }}
    >
      {children}
    </div>
  );
}